/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const AngleDownLightIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.65239 11.0721L1.89458 6.03915C1.70181 5.83835 1.70181 5.51364 1.89458 5.31284L2.18579 5.00949C2.37856 4.80869 2.69028 4.80869 2.88306 5.00949L7.00102 9.38022L11.119 5.01376C11.3118 4.81296 11.6235 4.81296 11.8163 5.01376L12.1075 5.31711C12.3002 5.51791 12.3002 5.84262 12.1075 6.04343L7.34966 11.0764C7.15688 11.2729 6.84516 11.2729 6.65239 11.0721Z"
        fill={color}
      />
    </svg>
  );
};
